<template>
    <v-container raw fluid xs12 style="margin: 0; padding: 0" transition="scroll-x-transition">
        <tutorial> </tutorial>
        <v-app-bar
            app
            clipped-left
            flat
            class="pa-0 ma-0"
            :color="!$vuetify.display.mobile ? 'transparent' : 'primary'"
            v-if="currentUser && currentUser.profile && $route.name !== 'maintenance'"
            :dense="$vuetify.display.mobile"
        >
            <ossAccountingFirmSelector v-if="hasMultiAccountingFirms"> </ossAccountingFirmSelector>
            <v-toolbar-title
                v-else
                style="max-width: 256px"
                color="transparent"
                class="d-flex justify-center align-center"
            >
                <img :src="logo" :height="40" />
            </v-toolbar-title>
            <v-row no-gutters class="fill-height bg-white rounded-bs-xl px-8">
                <v-col cols="7" class="d-flex align-center"> </v-col>
                <v-col cols="5" class="d-flex align-center justify-end">
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon=" $oss-outlined-home "
                                v-if="
                                    currentUser &&
                                    currentUser.profile.configuration.internalManagement.access
                                "
                                v-bind="props"
                                color="primary"
                                @click="accoutantHome()"
                                :style="topButtonStyle"
                            />
                        </template>
                        <span>Accueil</span>
                    </v-tooltip>
                    <!-- <v-btn
                        icon
                        color="primary"
                        @click="routerPush({name: 'admintasks'})"
                        :style="topButtonStyle"
                    >
                        <v-icon>$tune</v-icon>
                    </v-btn> -->
                    <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }"> -->
                    <!-- <div
                                v-on="on"
                                v-bind="attrs"
                            > -->
                    <profile-menu />
                    <!-- </div> -->
                    <!-- </template>
                        <span>Session</span>
                    </v-tooltip> -->
                    <!-- <v-img
                        src="../assets/img/icons/UserProfil.svg"
                        :width="$vuetify.display.mobile ? '25px':'40px'"
                        class="user_profil_btn"
                        @click="showUserProfil = !showUserProfil"
                        data-cy="index-showUserProfil"
                    /> -->
                    <oss-dialog
                        v-model="passwordChange"
                        minWidth="40%"
                        :persistent="firstLoginDialog"
                        valid-title="Modifier"
                        @valid="changePassword()"
                    >
                        <v-container>
                            <v-form ref="form" v-model="valid">
                                <v-row no-gutters>
                                    <v-col cols="12" v-if="firstLoginDialog" class="pb-2">
                                        Afin de garantire la sécurité de votre compte, merci de
                                        créer une nouveau mot de passe
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            outlined
                                            dense
                                            required
                                            :type="showPassword ? 'text' : 'password'"
                                            :append-inner-icon="
                                                showPassword ? '$fa-eye' : '$fa-eye-slash'
                                            "
                                            :rules="[
                                                () => password.length > 0 || 'empty password',
                                                () =>
                                                    password === pwdConfirmation ||
                                                    !(pwdConfirmation.length > 0) ||
                                                    'Passwords does not match',
                                            ]"
                                            @keyup.enter="changePassword"
                                            label="Nouveau mot de passe"
                                            v-model="password"
                                            density="compact"
                                            @click:append-inner="showPassword = !showPassword"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            outlined
                                            required
                                            type="password"
                                            :rules="[
                                                () =>
                                                    pwdConfirmation.length > 0 || 'empty password',
                                                () =>
                                                    password === pwdConfirmation ||
                                                    !(password.length > 0) ||
                                                    'Passwords does not match',
                                            ]"
                                            @keyup.enter="changePassword"
                                            label="Confirmer votre mot de passe"
                                            v-model="pwdConfirmation"
                                            density="compact"
                                        />
                                    </v-col>
                                    <!-- <v-col cols="12" class="d-flex justify-end">
                                            <v-btn rounded size="small" color="primary" elevation="0" @click="changePassword">Modifier</v-btn>
                                        </v-col> -->
                                </v-row>
                            </v-form>
                            <v-alert type="success" :model-value="isPasswordModified">
                                Votre mot de passe a bien ete modifie
                                <br />
                                <router-link :to="'/login'">Se connecter</router-link>
                            </v-alert>
                        </v-container>
                    </oss-dialog>
                </v-col>
            </v-row>
        </v-app-bar>
        <div v-if="showNavigationDrawer">
            <v-btn-icon
                v-if="mini"
                color="primary"
                size="x-small"
                elevation="0"
                @click.stop="mini = !mini"
                :style="styleMiniBtn"
                class="pl-3"
                icon="$fa-chevron-right"
                variant="flat"
                rounded="pill"
            >
            </v-btn-icon>
            <v-btn-icon
                v-else
                color="secondary"
                size="x-small"
                elevation="0"
                @click.stop="mini = !mini"
                :style="styleMiniBtn"
                class="px-0"
                icon="$fa-chevron-left"
                variant="flat"
                rounded="pill"
            >
            </v-btn-icon>
        </div>
        <v-navigation-drawer
            app
            clipped
            flat
            color="primary"
            floating
            class="navigation rounded-te-xl d-flex"
            :rail="mini"
            style="z-index: 99"
        >
            <v-list
                v-if="currentUser.id && currentUser && currentUser.profile"
                lines="one"
                :nav="true"
                base-color="white"
                density="compact"
                class="space-y-1"
            >
                <v-list-item>
                    <v-list-item-title class="v-list-item-title-active title primary--text">
                        Mon Cabinet
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="!isAccountingEmployee"
                    :to="{ name: 'my-companies-edition', params: { type: 'company' } }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-home</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        {{ selectedCompanyName }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'my-companies-edition', params: { type: 'users' } }">
                    <template v-slot:prepend>
                        <v-icon>$fa-user</v-icon>
                    </template>
                    <v-list-item-title
                        class="v-list-item-title-active"
                        v-if="!mini"
                        data-cy="index-utilisateurs"
                    >
                        Utilisateurs
                    </v-list-item-title>
                </v-list-item>

                <!-- v-calendar of Vuetify is an unfinished Labs and a lot of props doesn't work anymore -->
                <!-- <v-list-item
                    v-if="
                        currentUser.profile.configuration.task.read &&
                        company.profile &&
                        company.profile.activateTask
                    "
                    :to="{ name: 'admintasks' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$oss-calendar</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini"> Gestionnaire des t&#xe2;ches </v-list-item-title>
                </v-list-item> -->

                <v-list-item
                    v-if="currentUser.profile.configuration.engagementLetter.read"
                    :to="{ name: 'engagement-letters' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$oss-article</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Lettres de mission
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="selectedCompany.enableAccountingFirms"
                    :to="{ name: 'my-companies-edition', params: { type: 'accounting-firms' } }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-building</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Mes cabinets
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    :to="{ name: 'my-companies-edition', params: { type: 'clients-companies' } }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-building</v-icon>
                    </template>
                    <v-list-item-title
                        data-cy="index-mesDossiers"
                        class="v-list-item-title-active"
                        v-if="!mini"
                    >
                        Mes Dossiers
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    data-cy="index-mesDossiersGroupe"
                    v-if="
                        currentUser.profile.configuration.accountingWorkspace.read &&
                        selectedCompany.accountingFirm &&
                        selectedCompany.clientUserAccessRight === 'AVAILABLE_WORKSPACE'
                    "
                    :to="{
                        name: 'my-companies-edition',
                        params: { type: 'accounting-workspaces' },
                    }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-building</v-icon>
                    </template>
                    <v-list-item-title
                        data-cy="index-mesGroupesDossiers"
                        class="v-list-item-title-active"
                        v-if="!mini"
                    >
                        Mes groupes de dossiers
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="currentUser.profile.configuration.accountingFirmSettings.read"
                    :to="{ name: 'configuration', params: { companyId: selectedCompany.id } }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-building</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Paramètres
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="currentUser.profile.configuration.accounting.monitoring"
                    :to="{ name: 'auditMonitoring' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-chart-line</v-icon>
                    </template>
                    <v-list-item-title
                        data-cy="index-pilotage"
                        class="v-list-item-title-active"
                        v-if="!mini"
                    >
                        Pilotage
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="
                        currentUser.profile.configuration.internalManagement.userActivity &&
                        !isAccountingEmployee
                    "
                    :to="{ name: 'users-activities' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-chart-line</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Activité
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="
                        currentUser.profile.configuration.internalManagement.userActivity &&
                        !isAccountingEmployee
                    "
                    :to="{ name: 'tutorials-activities' }"
                >
                    <template #prepend>
                        <v-icon>$fa-chart-line</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Suivi d'apprentissage
                    </v-list-item-title>
                </v-list-item>

                <!-- <v-list-item
                @click="$router.push({name: 'inProgress'})"
                :value="'inProgress'"
                v-if="showOutStanding && isAllowedToCustomerOutstanding"
            >
                <template v-slot:prepend>
                    <v-icon>$fa-file-invoice</v-icon>
                </template>
                <template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">Encours clients</v-list-item-title>
                </template>
            </v-list-item> -->

                <v-list-item
                    v-if="
                        currentUser.profile.configuration.declaration.read && isAllowedToDeclaration
                    "
                    :to="{ name: 'adminTaxForm' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-file-invoice</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Déclarations
                    </v-list-item-title>
                </v-list-item>
                <v-divider />
                <v-list-item v-if="isSelfClient && !isAccountingEmployee">
                    <v-list-item-title class="v-list-item-title-active title primary--text">
                        Ma compta
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="isSelfClient && !isAccountingEmployee"
                    :to="{ name: 'my-companies-edition', params: { type: 'accounting-period' } }"
                >
                    <template v-slot:prepend>
                        <v-icon>$date_range</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Exercice comptable
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="isSelfClient && !isAccountingEmployee"
                    :to="{ name: 'my-companies-edition', params: { type: 'bank' } }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-university</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Banques
                    </v-list-item-title>
                </v-list-item>

                <!-- <v-list-item @click="$router.push({name: 'my-companies-edition',params:{ type:'establishments'}})">
                <template v-slot:prepend>
                    <v-icon>$storefront</v-icon>
                </template>
                <template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">Etablissements</v-list-item-title>
                </template>
            </v-list-item> -->

                <v-list-item
                    v-if="isSelfClient && !isAccountingEmployee"
                    :to="{ name: 'my-companies-edition', params: { type: 'legal' } }"
                >
                    <template v-slot:prepend>
                        <v-icon>$gavel</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Mentions légales
                    </v-list-item-title>
                </v-list-item>
                <v-divider />
                <v-list-item>
                    <v-list-item-title class="v-list-item-title-active title primary--text">
                        Divers
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="currentUser.profile.configuration.internalManagement.importEBIC"
                    :to="{ name: 'import-ebics' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$account_balance_wallet</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Import EBICS
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="
                        selectedCompany.siren !== '844122648' &&
                        currentUser.profile.configuration.internalManagement.bobbeeBilling
                    "
                    :to="{ name: 'billing-bobbee' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-file-invoice</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Facturation bobbee
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="enableAccountingRule && !isBusinessClientWithSingleCompany"
                    :to="{ name: 'company-scopes' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$rule</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Périmètre des règles
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="
                        selectedCompany.siren === '844122648' &&
                        currentUser.profile.configuration.internalManagement.bobbeeBilling
                    "
                    :to="{ name: 'bobbee-clients' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-file-invoice</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Clients bobbee
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentUser.isRoot" :to="{ name: 'companies-table' }">
                    <template v-slot:prepend>
                        <v-icon>$storefront</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Companies
                    </v-list-item-title>
                </v-list-item>

                <!-- <v-list-item
                @click="$router.push({name: 'users-table'})"
                :value="'users-table'"
                v-if="currentUser.profile.type === 'ROOT'"
            >
                <template v-slot:prepend>
                    <v-icon>$person</v-icon>
                </template>
                <template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">Users</v-list-item-title>
                </template>
            </v-list-item> -->

                <v-list-item v-if="currentUser.isRoot" :to="{ name: 'tags' }">
                    <template v-slot:prepend>
                        <v-icon>$label</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Tags
                    </v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'partitionstags-table' }">
                    <template v-slot:prepend>
                        <v-icon>$label</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Partitions génériques
                    </v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'accounting-plans' }">
                    <template v-slot:prepend>
                        <v-icon>$account_balance_wallet</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Plans comptables
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentUser.isRoot" :to="{ name: 'companyactivities-table' }">
                    <template v-slot:prepend>
                        <v-icon>$fa-university</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Codes NAF
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentUser.isRoot" :to="{ name: 'wording-analysis' }">
                    <template v-slot:prepend>
                        <v-icon>$chat_bubble</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Wordings
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentUser.isRoot" :to="{ name: 'partitionstags-table' }">
                    <template v-slot:prepend>
                        <v-icon>$list_alt</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Partitions Tags
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="currentUser.profile.configuration.profile.read"
                    :to="{ name: 'profiles-table' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$list_alt</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Profils
                    </v-list-item-title>
                </v-list-item>
                <!-- <router-link
                    v-if="currentUser.isRoot"
                    :to="{ name: 'invoice-number-pattern-table' }"
                >
                    <v-list-item :model-value="'invoice-number-pattern-table'">
                        <template v-slot:prepend>
                            <v-icon color="white">$list_alt</v-icon>
                        </template>

                        <v-list-item-title class="v-list-item-title-active" v-if="!mini" class="text-white"
                            >Structure n. fact. VTE</v-list-item-title
                        ></v-list-item
                    >
                </router-link> -->
                <v-list-item
                    v-if="currentUser.profile.configuration.accounting.audit"
                    :to="{ name: 'auditChecks', params: { mode: 'displayOnly' } }"
                >
                    <template v-slot:prepend>
                        <v-icon>$list_alt</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        {{ $t("menu." + "audit") }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="enableAccountingRule && isAllowedToRevision"
                    :to="{ name: 'AccountingReviewLayoutsTable' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$list_alt</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Dossiers de révision
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="enableAccountingRule && isAllowedToRestitution"
                    :to="{ name: 'booklet-templates' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$list_alt</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Plaquettes
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="enableAccountingRule && offerType === Offer_type.ACCOUNTING_PREMIUM"
                    :to="{ name: 'export-themes' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$list_alt</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Thèmes documents
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="enableAccountingRule" :to="{ name: 'wording-analysis' }">
                    <template v-slot:prepend>
                        <v-icon>$fa-vial</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Analyse de libellé
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="enableAccountingRule && isAllowedToInvoice"
                    :to="{ name: 'document-rule' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-vial</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        {{ $t("menu.documentRules") }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="enableAccountingRule && offerType === Offer_type.ACCOUNTING_PREMIUM"
                    :to="{
                        name: 'computedIndicatorTable',
                        params: { companyId: selectedCompany.id },
                    }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-vial</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Indicateurs personnalisés
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="enableAccountingRule && offerType === Offer_type.ACCOUNTING_PREMIUM"
                    :to="{ name: 'operatingAccountTable' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-vial</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Tableaux personnalisés
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentUser.isRoot" :to="{ name: 'companyCluster' }">
                    <template v-slot:prepend>
                        <v-icon>$fa-key</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Groupement GK
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="enableAccountingRule && offerType === Offer_type.ACCOUNTING_PREMIUM"
                    :to="{ name: 'export-office' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$oss-export</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Export Office
                    </v-list-item-title>
                </v-list-item>
                <v-divider />
                <v-list-item
                    v-if="enableAccountingRule && offerType === Offer_type.ACCOUNTING_PREMIUM"
                    :to="{ name: 'extensions' }"
                >
                    <template v-slot:prepend>
                        <v-icon>$fa-plug</v-icon>
                    </template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">
                        Extensions
                    </v-list-item-title>
                </v-list-item>

                <!-- <v-divider></v-divider>
            <v-list-item>
                <template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini" class="title primary--text">Dossiers</v-list-item-title>
                </template>
            </v-list-item>

            <v-list-item @click="$router.push({name: 'home' })">
                <template v-slot:prepend>
                    <v-icon>$fa-folder-open</v-icon>
                </template>
                <template>
                    <v-list-item-title class="v-list-item-title-active" v-if="!mini">Dossiers</v-list-item-title>
                </template>
            </v-list-item> -->
                <!-- </v-list-group> -->
            </v-list>
            <template v-slot:append>
                <v-row no-gutters v-if="!mini" class="mb-4">
                    <v-col cols="3" class="d-flex justify-end align-end text--primary px-1">
                        by
                    </v-col>
                    <v-col cols="9" class="d-flex">
                        <v-img src="../../assets/img/bobbee_hrz.png" :height="30" />
                    </v-col>
                </v-row>
                <v-row no-gutters v-else class="mb-4">
                    <v-col cols="12" class="d-flex justify-center">
                        <v-img src="../../assets/img/bobbee_mini.png" :height="30" />
                    </v-col>
                </v-row>
            </template>
        </v-navigation-drawer>
        <div
            v-if="isAuth()"
            class="background_image d-flex align-start fill-height"
            style="width: 100%; margin: 0"
        >
            <router-view
                transition="scroll-x-transition"
                v-scroll="onScroll"
                class="fill-height"
                style="width: 100%"
            />
        </div>
        <v-main
            raw
            fluid
            xs12
            class="background_image d-flex align-start fill-height"
            style="width: 100%; margin: 0"
            v-else
        >
            <router-view
                transition="scroll-x-transition"
                v-scroll="onScroll"
                v-if="$route.name === 'document' && !$vuetify.display.mobile"
                :key="$route.fullPath"
                v-slot="{ Component }"
            >
                <transition name="slide-fade">
                    <component :is="Component"></component>
                </transition>
            </router-view>
            <router-view
                transition="scroll-x-transition"
                v-scroll="onScroll"
                v-else-if="!$vuetify.display.mobile"
                v-slot="{ Component }"
            >
                <transition name="slide-fade">
                    <component :is="Component"></component>
                </transition>
            </router-view>
            <router-view
                transition="scroll-x-transition"
                v-scroll="onScroll"
                v-else-if="$route.name === 'document'"
                class="fill-height"
                v-slot="{ Component }"
            >
                <transition name="slide-fade">
                    <component :is="Component"></component>
                </transition>
            </router-view>
            <router-view
                transition="scroll-x-transition"
                v-scroll="onScroll"
                v-else
                class="fill-height"
                v-slot="{ Component }"
            >
                <transition name="slide-fade">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </v-main>
        <oss-dialog
            v-model="emailVerification"
            :max-width="$vuetify.display.mobile ? 'auto' : '40%'"
            v-if="!isAuth() && env.ENABLE_COGNITO"
            title="Vérification de votre e-mail"
            :valid-title="
                emailConfirmationResent ? 'e-mail envoyé' : 'Renvoyer l\'e-mail de validation'
            "
            :valid-disabled="emailConfirmationResent"
            @valid="sendEmailConfirmation()"
        >
            <v-card style="margin: auto; padding: 10px">
                <v-card-text>
                    <div>
                        Avant de continuer, vous devez valider votre e-mail. Nous vous avons envoyé
                        un e-mail pour vérifier votre adresse e-mail.
                    </div>
                    <div>Si vous ne voyez pas ce mail, vérifiez dans vos spams.</div>
                </v-card-text>
                <!-- <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                             size="small"
                            rounded
                            color="secondary"
                            @click="sendEmailConfirmation"
                            :disabled="emailConfirmationResent"
                        >{{emailConfirmationResent ? "e-mail envoyé" : "Renvoyer l'e-mail de validation"}}</v-btn>
                    </v-card-actions> -->
            </v-card>
        </oss-dialog>
        <v-snackbar
            v-model="apolloErrorSnackBar"
            :color="apolloErrors.type"
            multi-line
            timeout="5000"
        >
            {{ apolloErrors.errorType }} : {{ apolloErrors.request }}
            <div v-for="(msg, index) of apolloErrors.messages" :key="index">{{ msg }}</div>

            <template v-slot:actions>
                <v-btn @click="apolloErrorSnackBar = false" variant="text"> Close </v-btn>
            </template>
        </v-snackbar>
        <SnackbarSurvey></SnackbarSurvey>
    </v-container>
</template>
<script lang="ts">
import { Apollo, State2Way } from "@/decorators";
import moment from "moment-timezone";
import gql from "graphql-tag";

import { User } from "../../store/store";
import ProfileMenu from "../auth/ProfileMenu.vue";
import ChatList from "../chat/ChatList.vue";

import CLIENT_COMPANY_COUNT from "@/graphql/company/ClientCompanyCount.gql";
import ACCOUNTING_COMPANY_OF_COMPANY from "../../graphql/company/AccountingCompanyOfCompany.gql";
import UPDATE_USER_PASSWORD from "../../graphql/user/UpdateUserPassword.gql";

import Tutorial from "../Tutorial.vue";

import { updateMaintenance } from "../../services/updateMaintenance";

import ossAccountingFirmSelector from "../ossComponents/ossAccountingFirmSelector.vue";

import { Offer_type } from "@/types/offer.types";

import logoBobbeeMini from "../../assets/img/bobbee_mini.png";

import SnackbarSurvey from "@/components/snackbar/SnackbarSurvey.vue";
import getEnv from "@/env";
import { logOutUser } from "@/services/userServices";
import { Component, Vue, Watch, toNative } from "vue-facing-decorator";

const env = getEnv();

@Component({
    components: {
        ChatList,
        ProfileMenu,
        Tutorial,
        ossAccountingFirmSelector,
        SnackbarSurvey,
    },
})
export class Admin extends Vue {
    mini = false;
    drawer = null;

    firstLoginDialog = false;

    apolloErrorSnackBar = false;

    offsetTop = 0;

    localEnv = env.environnement;

    @State2Way("updateCurrentRoute", "currentRoute")
    currentRouteStore!: string;

    date = moment().format("DD-MM-YYYY");

    url_image_actu =
        "https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80";

    showUserProfil = false;

    passwordChange = false;

    password: string = "";

    pwdConfirmation: string = "";

    loading = false;

    showPassword = false;

    valid = false;

    isPasswordModified = false;

    alreadyAskedEmailVerification = false;
    emailConfirmationResent = false;

    companySearch = "";

    get currentRoute() {
        return this.$route.name;
    }

    get offerType() {
        return this.$store.state.offerType;
    }

    get accountingCompanyId() {
        return this.$store.state.companyAccountingFirm.id;
    }

    get Offer_type() {
        return Offer_type;
    }

    get isUserHasAccess() {
        if (this.$store.state.user.profile.type === "ACCOUNTING_CLIENT") {
            return false;
        } else {
            return true;
        }
    }

    get isAllowedToCustomerOutstanding() {
        switch (this.offerType) {
            case Offer_type.ACCOUNTING_ESSENTIAL:
            case Offer_type.ACCOUNTING_PREMIUM:
            case Offer_type.BUSINESS_SMART:
            case Offer_type.BUSINESS_ESSENTIAL:
            case Offer_type.BUSINESS_PREMIUM:
            case Offer_type.TRAINING:
                return true;
            default:
                return false;
        }
    }

    get isAllowedToDeclaration() {
        switch (this.offerType) {
            case Offer_type.ACCOUNTING_BASIC:
            case Offer_type.ACCOUNTING_ESSENTIAL:
            case Offer_type.ACCOUNTING_PREMIUM:
            case Offer_type.BUSINESS_PREMIUM:
            case Offer_type.TRAINING:
                return true;
            default:
                return false;
        }
    }

    get isAllowedToRevision() {
        switch (this.offerType) {
            case Offer_type.ACCOUNTING_BASIC:
            case Offer_type.ACCOUNTING_ESSENTIAL:
            case Offer_type.ACCOUNTING_PREMIUM:
            case Offer_type.BUSINESS_PREMIUM:
            case Offer_type.TRAINING:
                return true;
            default:
                return false;
        }
    }

    get isAllowedToRestitution() {
        switch (this.offerType) {
            case Offer_type.ACCOUNTING_BASIC:
            case Offer_type.ACCOUNTING_ESSENTIAL:
            case Offer_type.ACCOUNTING_PREMIUM:
            case Offer_type.BUSINESS_PREMIUM:
            case Offer_type.TRAINING:
                return true;
            default:
                return false;
        }
    }

    get isAllowedToInvoice() {
        switch (this.offerType) {
            case Offer_type.ACCOUNTING_BASIC:
            case Offer_type.ACCOUNTING_ESSENTIAL:
            case Offer_type.ACCOUNTING_PREMIUM:
            case Offer_type.BUSINESS_PREMIUM:
            case Offer_type.TRAINING:
                return true;
            default:
                return false;
        }
    }

    get isBusinessClient() {
        return this.currentUser.isBusinessClient;
    }

    get isBusinessClientWithSingleCompany() {
        return this.isBusinessClient && this.clientCompanyCount === 1;
    }

    @Watch("currentRoute")
    onCurrentRouteChange() {
        this.currentRouteStore = this.currentRoute.toString();
    }

    routerPush(options) {
        this.$router.push(options).catch(() => {});
    }

    accoutantHome() {
        this.$router.push({ name: "accountant-home" });
    }

    set currentMenu(data) {
        this.currentMenu = data;
    }

    get currentMenu() {
        switch (this.$route.name) {
            case "companies-edition": {
                if (this.$route?.params?.type === "company") {
                    return "companies-edition-company";
                } else if (this.$route?.params?.type === "users") {
                    return "companies-edition-user";
                } else if (this.$route?.params?.type === "clients-companies") {
                    return "companies-edition-clients";
                } else if (this.$route?.params?.type === "accounting-period") {
                    return "companies-edition-ap";
                } else if (this.$route?.params?.type === "bank") {
                    return "companies-edition-bank";
                } else if (this.$route?.params?.type === "legal") {
                    return "companies-edition-legal";
                }
                break;
            }
            case "admintasks":
                return "admintasks";
            case "engagement-letters":
                return "engagement-letters";
            case "configuration":
                return "configuration";
            case "auditMonitoring":
                return "auditMonitoring";
            case "users-activities":
                return "users-activities";
            case "inProgress":
                return "inProgress";
            case "adminTaxForm":
                return "adminTaxForm";
            case "import-ebics":
                return "import-ebics";
            case "export-office":
                return "export-office";
            case "billing-bobbee":
                return "billing-bobbee";
            case "bobbee-clients":
                return "bobbee-clients";
            case "companies-table":
                return "companies-table";
            case "users-table":
                return "users-table";
            case "tags":
                return "tags";
            case "companyactivities-table":
                return "companyactivities-table";
            case "wording-analysis":
                return "wording-analysis";
            case "partitionstags-table":
                return "partitionstags-table";
            case "profiles-table":
                return "profiles-table";
            case "invoice-number-pattern-table":
                return "invoice-number-pattern-table";
            case "auditChecks":
                return "auditChecks";
            case "AccountingReviewLayoutsTable":
                return "AccountingReviewLayoutsTable";
            case "booklet-templates":
                return "booklet-templates";
            case "export-themes":
                return "export-themes";
            case "wording-analysis":
                return "wording-analysis";
            case "document-rule":
                return "document-rule";
            case "computedIndicatorTable":
                return "computedIndicatortable";
            case "operatingAccountTable":
                return "operatingAccountTable";
            case "companyCluster":
                return "companyCluster";
            case "tutorials-activities":
                return "tutorials-activities";
            default:
                return null;
        }
    }

    get env() {
        return env;
    }

    get emailVerification() {
        return false;
        if (!env.ENABLE_COGNITO) return false;
        if (!this.currentUser || !this.currentUser.id) return false;
        if (!this.currentUser.emailVerified && !this.alreadyAskedEmailVerification) {
            return true;
        }
        return false;
    }

    set emailVerification(value) {
        if (!value) this.alreadyAskedEmailVerification = true;
    }

    backBtnList = {
        "reconciliation/bankTransaction": 1,
        "reconciliation/document": 1,
        toBeDone: 1,
        document: 1,
        expenseReportNew: 1,
        expenseReport: 1,
        zTillReceipt: 1,
    };

    @State2Way("updateToBeDoneStatus", "toBeDoneStatus")
    toBeDoneStatus!: boolean;

    bottomNav = 1;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get company() {
        return this.currentUser?.company;
    }

    get isAccountingEmployee() {
        return this.currentUser.isAccountingEmployee;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get showOutStanding() {
        // debugger
        if (!this.currentUser?.companyUser?.configuration?.outstanding) {
            return false;
        }
        const outstanding = this.currentUser?.companyUser.configuration.outstanding;
        if (
            !outstanding.expenseReport &&
            !outstanding.salary &&
            !outstanding.selectionClient &&
            !outstanding.client &&
            !outstanding.supplier
        ) {
            return false;
        }

        return true;
    }

    get enableAccountingRule() {
        return this.currentUser?.profile.configuration.accountingRule.read;
    }

    get logo() {
        if (this.company?.logo?.signedUrl) {
            return this.company.logo.signedUrl;
        }
        return logoBobbeeMini;
    }

    get selectedCompany() {
        return this.$store.state.user.company;
    }

    get selectedCompanyName() {
        return this.selectedCompany?.shortName || this.selectedCompany?.name || "XXX";
    }

    @Watch("selectedCompany")
    onSelectedCompanyChanged() {}

    get topButtonStyle() {
        const style = "pointer-events:auto; margin-right: 3px;";
        return style;
    }

    get topButtonColor() {
        if (this.$vuetify.display.mobile) return "";
        return "primary";
    }

    get topButtonText() {
        if (this.$vuetify.display.mobile) return true;
        return false;
    }

    get topButtonFab() {
        if (this.$vuetify.display.mobile) return false;
        return true;
    }

    get showNavigationDrawer() {
        if (this.$route.name === "maintenance") return false;
        if (this.$vuetify.display.mobile) return false;
        if (!this.currentUser || !this.currentUser.profile) return false;
        if (this.toBeDoneStatus) return false;

        const history = (this.$router as any).history;

        return true;
    }

    get styleMiniBtn() {
        if (this.mini) {
            return "position: fixed; bottom: 10px; left: 40px; transition: all 280ms ease; z-index: 4";
        }
        return "position: fixed; bottom: 10px; z-index: 100; left: 237px; transition: all 280ms ease;";
    }

    get hasMultiAccountingFirms() {
        if (this.company.accountingFirm && this.company.enableAccountingFirms) {
            return true;
        } else if (
            this.currentUser.isSubUserOf?.id &&
            this.currentUser.isSubUserOf.company.accountingFirm &&
            this.currentUser.isSubUserOf.company.enableAccountingFirms
        ) {
            return true;
        } else {
            return false;
        }
    }

    @Apollo({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables() {
            return {
                companyId: this.company.id,
            };
        },
        skip() {
            return !this.currentUser.id || !this.company;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.isSelfClient = data.companies.find((c) => c.id === this.company.id)
                        ? true
                        : false;
                    if (this.isSelfClient) {
                        this.isSelfClient = this.currentUser.allAvailableCompanies.find(
                            (ac) => ac.id === this.company.id,
                        )
                            ? true
                            : false;
                    }
                } else {
                    this.isSelfClient = false;
                }
            }
        },
    })
    isSelfClient: boolean = false;

    @Apollo({
        query: CLIENT_COMPANY_COUNT,
        variables() {
            return {
                companyId: this.accountingCompanyId,
            };
        },
        skip() {
            return !this.isBusinessClient;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                debugger;
                if (data.clientCompanyCount) {
                    this.clientCompanyCount = data.clientCompanyCount;
                }
            }
        },
    })
    clientCompanyCount: number = 0;

    get margin() {
        if (this.offsetTop < 30) {
            return "padding-bottom: 0px";
        }
        return "pointer-events:none; padding-bottom:" + (this.offsetTop - 30) * 2 + "px";
    }

    beforeMount() {
        this.$store.commit("setInternalManagement", true);

        this.$apollo.addSmartQuery("applicationSettings", {
            query: gql`
                query applicationSettings {
                    applicationSettings(where: { name: "web" }) {
                        id
                        maintenance
                    }
                }
            `,
            result: ({ data, loading, networkStatus }: any) => {
                if (!loading) {
                    if (data && data.applicationSettings) {
                        updateMaintenance(
                            this.$route,
                            this.$store,
                            this.$router,
                            data.applicationSettings,
                        );
                    }
                }
            },
        });
    }

    beforeDestroy() {
        this.$store.commit("setInternalManagement", false);
    }

    async logout() {
        // this.$store.commit("logoutUser");
        logOutUser(this.$store, this.$router);
    }

    onScroll(e) {
        this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    }

    resetChangePassword() {
        this.password = "";
        this.pwdConfirmation = "";
        this.passwordChange = false;
    }

    changePassword() {
        if (!this.$refs.form.validate()) return;
        this.loading = true;
        this.$apollo.mutate({
            mutation: UPDATE_USER_PASSWORD,
            variables: {
                userId: this.currentUser.id,
                password: this.password,
            },
            update: (data) => {
                this.isPasswordModified = true;
            },
        });
        this.loading = false;
        this.resetChangePassword();
    }

    isAuth() {
        const name = this.$route.name;
        if (
            name === "login" ||
            name === "signup" ||
            name === "password-recovery" ||
            name === "password-reset" ||
            name === "email-verification" ||
            name === "maintenance"
        ) {
            return true;
        }
        return false;
    }

    async sendEmailConfirmation() {
        if (!this.emailConfirmationResent) {
            await this.$apollo.mutate({
                mutation: gql(`mutation{sendEmailConfirmation{status}}`),
            });
            this.emailConfirmationResent = true;
        }
    }

    get apolloErrors() {
        console.log(this.$store.state.apolloErrors);
        return this.$store.state.apolloErrors;
    }

    @Watch("apolloErrors")
    test() {
        console.log("errors", this.apolloErrors);
        this.apolloErrorSnackBar = true;
        this.loading = false;
    }
}

export default toNative(Admin);
</script>
<style scoped>
.v-content__wrap {
    height: 100% !important;
}
span.company-name {
    margin-left: 5px;
}

.background_image {
    background-color: #f4f4f4;
}

.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 16px;
}

.navigation a {
    text-decoration: none !important;
}

.v-list-item-title-active {
    font-size: 0.9rem;
    line-height: 1.4;
    white-space: normal;
    word-break: break-word;
}
</style>
